import React from 'react'
import {useTranslation} from 'react-i18next'
import {LabelCheckbox, Label} from '../../../Atoms/Forms'
import styled from 'styled-components'
import {AdjustableContainer} from '../../../Layout/Layout'
import {getAlarmMethodName} from './AlarmSettingsUtils'

const AlarmMethodsWrapper = styled.div`
  margin: 3rem 0 1rem 0;
`

interface AlarmMethodsProps {
  controller: {
    selected: string[]
    options: string[]
    toggle: (id: string) => void
  }
}

const AlarmMethodWidget = ({controller: amc}: AlarmMethodsProps) => {
  const {t} = useTranslation('alarms')
  return amc.options && amc.options.length ? (
    <AlarmMethodsWrapper>
      <Label required htmlFor={'method-select'}>
        {t('alarms:labels.messageType', 'Message type')}
      </Label>
      <AdjustableContainer id={'method-select'} padding="1rem 0rem">
        {amc.options.map((method: string) => (
          <div key={method}>
            <LabelCheckbox
              // disable push notification option until it's available
              // disabled={method === AlarmMethod.PUSH}
              flipped={false}
              checked={amc.selected.includes(method)}
              label={getAlarmMethodName(method)}
              name={method}
              onClick={() => amc.toggle(method)}
            />
          </div>
        ))}
      </AdjustableContainer>
    </AlarmMethodsWrapper>
  ) : null
}

export default AlarmMethodWidget
